
import * as Sentry from "@sentry/react";

/**
 * Start a transaction for website content analysis
 */
export function startAnalysisTransaction(): Sentry.Transaction | null {
  try {
    return Sentry.startTransaction({
      name: "website-analysis",
      op: "analysis",
    });
  } catch (error) {
    console.error("Error starting Sentry transaction:", error);
    return null;
  }
}

/**
 * Configure Sentry scope for website analysis
 */
export function configureAnalysisScope(url: string): void {
  try {
    Sentry.configureScope(scope => {
      scope.setTag("feature", "website_analysis");
      scope.setContext("analysis", {
        url
      });
    });
  } catch (error) {
    console.error("Error configuring Sentry scope:", error);
  }
}

/**
 * Start a transaction for website content fetching
 */
export function startContentFetchTransaction(): Sentry.Span {
  try {
    const transaction = Sentry.startTransaction({
      name: "website-content-fetch",
      op: "fetch",
    });
    
    return transaction.startChild({
      op: "http.request",
      description: "Fetch website content",
    });
  } catch (error) {
    console.error("Error starting Sentry span:", error);
    // Return a dummy span object that won't cause errors when finish() is called
    return {
      finish: () => {},
    } as Sentry.Span;
  }
}

/**
 * Configure Sentry scope for content fetching
 */
export function configureContentFetchScope(url: string): void {
  try {
    Sentry.configureScope(scope => {
      scope.setTag("operation", "content_fetch");
      scope.setContext("fetch_details", {
        url
      });
    });
  } catch (error) {
    console.error("Error configuring Sentry scope for content fetch:", error);
  }
}
